import { createVuetify } from 'vuetify'
import defaults from './defaults'
import theme from './theme'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import "@mdi/font/css/materialdesignicons.css";
import 'vuetify/styles'

export default createVuetify({
  components,
  directives,
  defaults,
  theme,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
})
